import React from 'react';
    import { HashRouter as Router, Routes, Route } from 'react-router-dom';
    import Header from './components/Header';
    import Hero from './components/Hero';
    import Features from './components/Features';
    import HowItWorks from './components/HowItWorks';
    import AppPreview from './components/AppPreview';
    import Download from './components/Download';
    import Footer from './components/Footer';
    import Terms from './components/Terms';
    import Privacy from './components/Privacy';

    const Home = () => (
      <>
        <Header />
        <Hero />
        <Features />
        <HowItWorks />
        <AppPreview />
        <Download />
        <Footer />
      </>
    );

    const LegalPage = ({ children }) => (
      <>
        <Header />
        {children}
        <Footer />
      </>
    );

    function App() {
      return (
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-rose-light via-white to-rose-accent/20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/terms" element={<LegalPage><Terms /></LegalPage>} />
              <Route path="/privacy" element={<LegalPage><Privacy /></LegalPage>} />
            </Routes>
          </div>
        </Router>
      );
    }

    export default App;